import { Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import PDFDivider from '@/components/ReportPDF/PDFDivider'
import { parseDateToTaiwanDate } from '../../TaiwanDateConvert'

const Chapter2Page = ({ reportData, setPage }) => {
  const { reprotDao, phishCampaignReport, phishType, secondaryCompanyNickname } = reportData || {}
  const {
    companyName,
    campaignStartDate,
    campaignEndDate,
    sendTotalCount,
    sendSuccessCount,
    sendFailCount,
    userCount,
  } = reprotDao || {}
  const service = phishType
  const sendCount = userCount > 0 ? sendTotalCount / userCount : 0

  const {
    openCount,
    linkCount,
    fileCount,
    textCount,
    openPercent,
    linkPercent,
    filePercent,
    textPercent,
  } = phishCampaignReport || {}

  const formatPercent = value => {
    // 檢查是否存在且為數字，並且小數點後超過 2 位才進行處理
    if (value != null) {
      const strValue = value.toString()
      const decimalPart = strValue.split('.')[1] // 小數部分
      return decimalPart && decimalPart.length > 2 ? value.toFixed(2) : value
    }
    return '0.00' // 如果數值不存在或無效，回傳 '0.00'
  }

  const formattedReport = {
    userCount,
    openCount,
    openPercent: formatPercent(openPercent),
    linkCount,
    linkPercent: formatPercent(linkPercent),
    fileCount,
    filePercent: formatPercent(filePercent),
    textCount,
    textPercent: formatPercent(textPercent),
  }

  return (
    <PDFPage title="第二章 執行摘要" reportData={reportData}>
      <View
        style={{
          width: '100%',
          height: 5, // 設置分隔線的高度
          backgroundColor: 'black', // 設置顏色為黑色
          marginBottom: 30,
        }}
      >
        <PDFDivider style={{ width: '100%' }} />
      </View>
      <View>
        <Text
          style={{
            marginTop: 20,
          }}
          render={({ pageNumber }) => {
            setPage({ chap2: pageNumber })
          }}
        />
        <PDFParagraph>
          {'    '}本文件提出對
          <Text>{companyName}</Text>
          的受測單位及受測對象進行社交工程郵件演練的結果。此項測試的目的是辨識出可能會因惡意郵件攻擊的狀況進行實測與分析，並給予改善建議。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}
          <Text>{secondaryCompanyNickname}</Text>
          協助
          <Text>{companyName}</Text>
          檢視現有社交工程安全防護，並依照
          <Text>{companyName}</Text>
          之需求執行社交工程郵件演練，本專案檢測服務檢測時程為
          <Text style={{ textDecoration: 'underline' }}>
            {parseDateToTaiwanDate(campaignStartDate)}至{parseDateToTaiwanDate(campaignEndDate)}
          </Text>
          。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}本次社交工程
          <Text>{service}</Text>
          演練專案，著重於測試
          <Text>{companyName}</Text>
          的整體工作同仁對於惡意
          <Text>{service}</Text>
          之警覺性，以降低社交工程攻擊風險，檢測標的為
          <Text>{companyName}</Text>
          內部指定電子郵件帳號進行檢測，每個電子郵件帳號進行
          <Text style={{ fontWeight: 'bold' }}>{sendCount || 0}</Text>
          封社交工程郵件測試，且每帳號
          <Text style={{ fontWeight: 'bold' }}>{sendCount || 0}</Text>
          封的測試郵件均可在客戶指定的時間範圍內分次不定期寄送，以達到最佳測試效果。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}依社交工程測試專案服務之要求，檢測郵件內容設計可涵蓋不同類型。本次
          <Text>{companyName}</Text>
          檢測範本內容可參考章節3.6之內容。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}
          第四章的測試分析結果整理出的報表、圖表會按照受測人數及檢測範本等各類不同面向的統計資訊，詳細列出了
          <Text>{secondaryCompanyNickname}</Text>
          在執行期間所檢測的各項檢測結果，以及建議解決方式。
          <Text>
            由檢測結果可得知本次受測對象共
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.userCount || 0}</Text>
            人，總演練郵件數為
            <Text style={{ fontWeight: 'bold' }}>{sendTotalCount || 0}</Text>
            封，實際發送郵件數為
            <Text style={{ fontWeight: 'bold' }}>{sendTotalCount || 0}</Text>
            封，無法投遞郵件
            <Text style={{ fontWeight: 'bold' }}>{sendFailCount || 0}</Text>
            封，瀏覽測試郵件之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.openCount || 0}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.openPercent || 0}</Text>
            %；點閱測試連結之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.linkCount || 0}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.linkPercent || 0}</Text>
            %；開啟測試附件之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.fileCount || 0}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.filePercent}</Text>
            %；輸入資料之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.textCount || 0}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedReport.textPercent || 0}</Text>
            %。多數受測者具有相當警覺性，未瀏覽社交檢測信件，但仍有受測者未詳查寄件來源或身分，建議可針對此類受測者進行教育訓練，藉此訓練受測者自身資安意識的強化。
          </Text>
        </PDFParagraph>

        <PDFParagraph>
          {'    '}
          為避免遭受有心人士利用，後續的解決方案除了教育訓練與自身資安意識的強化，請客戶也應當建立相關的資訊安全政策，並定期舉行教育訓練以及社交工程郵件演練，使其能夠在日新月異的技術變化之中，持續維持安全性。
        </PDFParagraph>
      </View>
    </PDFPage>
  )
}

export default Chapter2Page
